import React from 'react';
import ReactSelectFormatter from "../../services/ReactSelectFormatter";
import {messages} from "../common/Translations";
import Card from '../Card';
import 'react-sortable-tree/style.css';
import dynamicImport from '../common/dynamicImport';
import NodeContent from '../categories/NodeContent';
import SearchForm from '../categories/SearchForm';
import {injectIntl} from "react-intl";
import Modal from '../Modal';
import PropTypes from 'prop-types';
import {toastr} from "react-redux-toastr";

class TreeEditorCompetencies extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            flatData: [],
            treeData: [],
            searchQuery: '',
            searchMatches: [],
            searchFocusIndex: 0,
            showCreateModal: false,
            showDeleteModal: false,
            competencyToCreateTitle: '',
            parentIdForNewElement: null,
            processedCompetenciesForSelect: []
        };
    }

    componentDidMount() {
        this.updateTree();
    }


    componentDidUpdate(prevProps) {
        if (prevProps.fetchedData !== this.props.fetchedData) {
            this.updateTree();
        }
    }

    onSelectPrevMatch(searchFoundCount) {
        const searchFocusIndex = this.state.searchFocusIndex;

        this.setState({
            searchFocusIndex:
                searchFocusIndex !== null
                    ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
                    : searchFoundCount - 1,
        });
    }

    onSelectNextMatch(searchFoundCount) {
        const searchFocusIndex = this.state.searchFocusIndex;

        this.setState({
            searchFocusIndex:
                searchFocusIndex !== null
                    ? (searchFocusIndex + 1) % searchFoundCount
                    : 0,
        });
    }

    onSearchComplete(searchMatches) {
        this.setState({searchMatches});
    }

    updateTree() {
//        console.log('test');
        const treeData = this.props.modules.sortableTree.getTreeFromFlatData({
            flatData: this.props.fetchedData,
            rootKey: 0
        });

        this.setState(
            {
                treeData,
                processedCompetenciesForSelect: ReactSelectFormatter.format(this.props.fetchedData)
            });
    }

    onSearch(searchQuery) {
        //@TODO debounce
        this.setState({searchQuery});
    }

    onDelete(rowInfo) {
        this.rowToDelete = rowInfo;

        if (this.rowToDelete.node.used) {
            toastr.error(this.props.intl.formatMessage(messages.competenciesWebmasterComUsed))
        } else if (this.rowToDelete.node.children !== undefined) {
            toastr.error(this.props.intl.formatMessage(messages.competenciesWebmasterComHasChildren))
        }
        else {
            this.setState({showDeleteModal: true});
        }
    }

    onNodeNameEdit(treeData, params) {
//        params.order = this.calculateOrder(treeData, params.id);
//        console.log(treeData, params);
        this.props.onNodeNameEdit(params);
        this.setState({treeData});
    }

    // Search for a query string inside a node property
    stringSearch(key, searchQuery, node, path, treeIndex) {
        if (typeof node[key] === 'function') {
            // Search within text after calling its function to generate the text
            return (
                (String(node[key]({ node, path, treeIndex }))).toLowerCase().indexOf(searchQuery.toLowerCase()) > -1
            );
        } else if (typeof node[key] === 'object') {
            // Search within text inside react elements
            return (getReactElementText(node[key])).toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
        }

        // Search within string
        return node[key] && (String(node[key]).toLowerCase().indexOf(searchQuery.toLowerCase()) > -1);
    }

    searchMethodCustom({ node, path, treeIndex, searchQuery }) {
        if (searchQuery.length === 0) {
            return false;
        }
        return (
            this.stringSearch('title', searchQuery, node, path, treeIndex) ||
            this.stringSearch('subtitle', searchQuery, node, path, treeIndex)
        );
    }

    clearSearch() {
        this.setState({searchQuery: ''});
    }

    renderNode(rowInfo) {
        return (
            <NodeContent
                key={rowInfo.node.id}
                rowInfo={rowInfo}
                treeData={this.state.treeData}
                onEditingConfirmed={this.onNodeNameEdit.bind(this)}
                onDelete={this.onDelete.bind(this)}
                searchMatches={this.state.searchMatches}
            />
        );
    }

    renderSearchForm() {
        return (
            <SearchForm
                onSearch={this.onSearch.bind(this)}
                selectPrevMatch={this.onSelectPrevMatch.bind(this)}
                selectNextMatch={this.onSelectNextMatch.bind(this)}
                clearSearch={this.clearSearch.bind(this)}
                matches={this.state.searchMatches}
                searchQuery={this.state.searchQuery}
                searchFocusIndex={this.state.searchFocusIndex}
            />
        );
    }

    onCloseCreateModal() {
        this.setState({showCreateModal: false})
    }

    showCreateModal() {
        this.setState({showCreateModal: true})
    }

    onCreateConfirm() {
        let params = {
            title: this.state.competencyToCreateTitle,
            parentId: this.state.parentIdForNewElement
        };
        this.props.onCreatedNode(params);
        this.setState({showCreateModal: false});
    }

    onCloseDeleteModal() {
        this.setState({showDeleteModal: false});
    }

    onDeleteConfirm() {
        const result = this.props.modules.sortableTree.removeNode({
            treeData: this.state.treeData,
            path: this.rowToDelete.path,
            getNodeKey: ({node: treeNode, treeIndex: treeIndex}) => treeIndex
        });

        this.props.onDeletedNode(this.rowToDelete.node.id);
        this.setState({treeData: result.treeData, showDeleteModal: false});
    }

    renderCreateModal() {
        return (
            <Modal
                confirm={this.onCreateConfirm.bind(this)}
                isOpen={this.state.showCreateModal}
                title={this.props.intl.formatMessage(messages.competenciesWebmasterCreateModalTitle)}
                close={this.onCloseCreateModal.bind(this)}
                onSubmit={this.onCreateConfirm.bind(this)}
                confirmText={this.props.intl.formatMessage(messages.categoriesWebmasterCreateBtn)}

            >
                {this.props.children}
            </Modal>
        )
    }

    renderDeleteModal() {
        return (
            <Modal
                title={this.props.intl.formatMessage(messages.categoriesWebmasterModalTitle)}
                isOpen={this.state.showDeleteModal}
                confirmText={this.props.intl.formatMessage(messages.categoriesWebmasterModalConfirmBtn)}
                closeText={this.props.intl.formatMessage(messages.categoriesWebmasterModalCancelBtn)}
                confirm={this.onDeleteConfirm.bind(this)}
                close={this.onCloseDeleteModal.bind(this)}
            >
                <p>
                    {this.props.onDeleteModalText}
                </p>
            </Modal>
        );
    }

    onMovedNode(changedTree) {
//        console.log(changedTree);
        let params = {
            id: changedTree.node.id,
            name: changedTree.node.title,
            parentId: changedTree.nextParentNode !== null ? changedTree.nextParentNode.id : 1,
            order: changedTree.treeIndex,
            prevOrder: changedTree.prevTreeIndex,
            // path contains array of item indexes from root to this child,
            // so its length means level
            level: changedTree.path.length
        };

        this.setState({treeData: changedTree.treeData});
        this.props.onMovedNode(params);
    }

    renderSortableTree() {
        const SortableTree = this.props.modules.sortableTree.default;
        //@TODO Make search case insensitive
        return (
            <SortableTree
                treeData={this.state.treeData}
                onMoveNode={this.onMovedNode.bind(this)}
                onChange={treeData => this.setState({treeData})}
                generateNodeProps={rowInfo => ({title: this.renderNode.bind(this)})}
                searchQuery={this.state.searchQuery}
                searchMethod={this.searchMethodCustom.bind(this)}
                expandOnlySearchedNodes
                searchFinishCallback={this.onSearchComplete.bind(this)}
                searchFocusOffset={this.state.searchFocusIndex}
            />
        );
    }

    render() {
        return (
            <Card
                title={this.props.title}
                creationLabel="Create a new one"
            >
                <h4>{this.props.subTitle}</h4>
                <div className="row">
                    <div className="col-sm-12">
                        <button
                            onClick={this.showCreateModal.bind(this)}
                            className="btn btn-primary waves-effect pull-right"
                        >
                            {this.props.intl.formatMessage(messages.categoriesWebmasterCreateBtn)}
                        </button>
                    </div>
                </div>
                {this.renderCreateModal()}
                <br />
                {this.renderSearchForm()}

                <div style={{height: 800}}>
                    {this.renderSortableTree()}
                </div>

                {this.renderDeleteModal()}

            </Card>
        );
    }
}

TreeEditorCompetencies.defaultProps = {
    fetchedData: [],
    onDeleteModalText: 'Er du sikker?'
};

TreeEditorCompetencies.propTypes = {
    renderDeleteComponent: PropTypes.func,
    renderCreateComponent: PropTypes.func,
    onMovedNode: PropTypes.func,
    onDeletedNode: PropTypes.func,
    onCreatedNode: PropTypes.func,
    fetchedData: PropTypes.array,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    onDeleteModalText: PropTypes.string
};

const imports = {sortableTree: import(/* webpackChunkName: "react-sortable-tree" */'react-sortable-tree')};

export default injectIntl(dynamicImport(TreeEditorCompetencies, imports));


// WEBPACK FOOTER //
// ./web/src/components/editors/TreeEditorCompetencies.jsx